import React from "react";
import { DialogTitleProps } from "./ViewDocument";
import { useActions } from "../../../../../actions";
import * as ClientActions from "../../../../../actions/client";
import { blue } from "@material-ui/core/colors";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    IconButton,
    Typography,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme, withStyles } from "@material-ui/core/styles";

const defaultTitle = "";
const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            wrapper: {
                position: "relative",
            },
            buttonProgress: {
                color: blue[500],
                position: "absolute",
                top: "10px",
                left: "50%",
                marginTop: "0px",
                width: "100%",
            },
        }),
);

const styles = (theme: Theme) =>
        createStyles({
            root: {
                margin: 0,
                padding: theme.spacing(2),
            },
            closeButton: {
                position: "absolute",
                right: theme.spacing(1),
                top: "18px",
                color: theme.palette.grey[500],
            },
        });

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                            <CloseIcon className="f20" />
                        </IconButton>
                ) : null}
            </MuiDialogTitle>
    );
});

export default function OfferTypeModal({
                                           open,
                                           title = defaultTitle,
                                           handleClose,
                                           buttonLoader = false,
                                           newOffer,
                                           setNewOffer,
                                           carrierId,
                                           setModalBox,
                                       }: any) {
    const clientActions = useActions(ClientActions);
    const [offerTypeDD, setOfferTypeDD] = React.useState([{
        id: 0,
        value: "all",
        name: "All",
    }]);

    React.useEffect(() => {
        (
                async () => {
                    if (carrierId) {
                        const offerTypes = await clientActions.getOfferByCarrierId(carrierId);
                        setOfferTypeDD(offerTypes && offerTypes.payload);
                    }
                }
        )();
    }, []);
    const classes = useStyles();

    return (
            <Dialog
                    fullWidth={true}
                    maxWidth={"sm"}
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {title}
                </DialogTitle>
                <DialogContent dividers>
                    <div id="alert-dialog-description">
                        <Grid item xs={12} md={12} lg={12}>
                            <FormControl variant="outlined" fullWidth={true}>
                                <InputLabel htmlFor="imo-type" shrink required={true}>Offer Type</InputLabel>
                                <Select className="muiSelect" value={newOffer}
                                        onChange={e => setNewOffer(e.target.value as string)} fullWidth>
                                    {
                                        offerTypeDD.map((o) =>
                                                <MenuItem key={o.id} value={o.value}>
                                                    {o.name}
                                                </MenuItem>)
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                    </div>
                    <span className="clearFix" />
                    <Button size="small"
                            className="bgRed floatLeft  floatRightSM mt20 ml15 mlSm0 mr5"
                            type="submit"
                            variant="contained"
                            disabled={buttonLoader}
                            color="primary" onClick={() => setModalBox(true)} autoFocus>
                        Submit
                        {buttonLoader &&
                                <CircularProgress className={classes.buttonProgress}
                                                  size={24} />}
                    </Button>
                </DialogContent>
            </Dialog>
    );
}